import { ReactNode } from "react";

interface PhotoDiscussionsPropsI {
	children: ReactNode;
}

function PhotoDiscussions(props: PhotoDiscussionsPropsI) {
	return <div className="photo-comments-component-main-container">{props.children}</div>;
}

export default PhotoDiscussions;
